/**
 * Botón "Los sueños se cumplen" de la home: abre el tebeo (/album/) en una capa a pantalla
 * completa. El iframe se crea al abrir y se destruye al cerrar, así la home no carga nada
 * del álbum (ni CSS, ni JS, ni imágenes) hasta que alguien pulsa.
 */

const overlay = document.querySelector<HTMLElement>('[data-album-overlay]');
const frameBox = overlay?.querySelector<HTMLElement>('[data-album-frame]');
const closeBtn = overlay?.querySelector<HTMLButtonElement>('[data-album-close]');
const openers = document.querySelectorAll<HTMLElement>('[data-album-open]');

if (overlay && frameBox && closeBtn && openers.length) {
  const root = document.documentElement;
  const src = overlay.dataset.albumSrc ?? '/album/?embed=1';
  let lastFocus: HTMLElement | null = null;
  let prefetched = false;

  const isOpen = () => !overlay.hidden;

  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement as HTMLElement | null;
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = overlay!.getAttribute('aria-label') ?? '';
    iframe.addEventListener('load', () => iframe.contentWindow?.focus());
    frameBox!.replaceChildren(iframe);
    overlay!.hidden = false;
    root.style.overflow = 'hidden';
    closeBtn!.focus();
  }

  function close() {
    if (!isOpen()) return;
    overlay!.hidden = true;
    frameBox!.replaceChildren();
    root.style.overflow = '';
    lastFocus?.focus();
  }

  // Precarga ligera al acercarse al botón: el clic abre casi al instante
  function prefetch() {
    if (prefetched) return;
    prefetched = true;
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = src;
    document.head.append(link);
  }

  openers.forEach((el) => {
    el.addEventListener('click', open);
    el.addEventListener('pointerenter', prefetch, { once: true });
    el.addEventListener('focus', prefetch, { once: true });
  });
  closeBtn.addEventListener('click', close);
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  // Mensajes del álbum embebido: cerrar o ir a una sección de la home (p. ej. el contacto)
  window.addEventListener('message', (e) => {
    if (e.origin !== location.origin || e.data?.type !== 'vantalus-album') return;
    if (e.data.action === 'close') close();
    if (e.data.action === 'goto' && typeof e.data.hash === 'string') {
      close();
      document.querySelector(e.data.hash)?.scrollIntoView({ behavior: 'smooth' });
    }
  });
}
